import classNames from 'classnames';
import { AvailableStreamCard } from 'components/cards/availableStreamCard';
import { AmbienteContext } from 'context/Ambiente';
import { useGetGuardaSuSnaiQuery } from 'features/api/sportApiSlice';
import { SportCarousel } from 'features/sport/components/sportCarousel';
import { useHideNavigationCarousel } from 'hooks/useHideNavigationCarousel';
import React, { useEffect } from 'react';
import { SwiperSlide } from 'swiper/react';
import { isServerSide } from 'utility/constant';
import { isTruthy } from 'utility/functions';
import styles from './AvailableStreamsCarousel.module.scss';

export type AvailableStreamsCarouselProps = {
  title: string;
  className: string;
  noPaddingRight?: boolean;
};

export const AvailableStreamsCarousel = ({ title, className, noPaddingRight }: AvailableStreamsCarouselProps) => {
  const { data, isLoading } = useGetGuardaSuSnaiQuery(undefined, {
    pollingInterval: 300000,
    skip: isServerSide,
    refetchOnMountOrArgChange: true,
  });

  const { avvenimentoList } = data ?? {};

  const { isScrollable, swiperSlideRef } = useHideNavigationCarousel({
    className: 'disabled',
    items: avvenimentoList ?? [],
  });

  if (isLoading || !isTruthy(avvenimentoList?.length)) return <React.Fragment key={`${title}-${className}`} />;

  return (
    <AmbienteContext.Provider
      value={{
        ambiente: 'sport',
        pathScommessa: ['api', 'queries', 'getGuardaSuSnai(undefined)', 'data'],
      }}
    >
      <SportCarousel
        title={title}
        className={className}
        navigation={isScrollable}
        classNameTitle={styles.paddingLeft}
        hasNoLeftPadding
        translateElement={[20, 40, 40]}
        classNameWrapper={classNames(styles.wrapper, 'backgroundElementWithMargin')}
        hasNoPaddingRight={noPaddingRight}
        onInit={(core) => (swiperSlideRef!.current = core.el)}
      >
        {avvenimentoList?.map((item) => (
          <SwiperSlide key={item.key}>
            <AvailableStreamCard avvenimentoKey={item.key} />
          </SwiperSlide>
        ))}
      </SportCarousel>
    </AmbienteContext.Provider>
  );
};
